import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { Room, WindowRefService } from '@app/core';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-room-details',
    templateUrl: './room-details.component.html',
    styleUrls: ['./room-details.component.scss'],
})
export class RoomDetailsComponent implements OnInit {
    detailRoom: { room: Room, facilities: Array<any>};
    @ViewChild(NgbCarousel) carousel: NgbCarousel;

    constructor(private winRef: WindowRefService, private dialogRef: MatDialogRef<RoomDetailsComponent>, @Inject(MAT_DIALOG_DATA) data) {
        this.detailRoom = data;
    }

    getBaseUrlImg(size: string): string {
        return this.winRef.appConfigSite.hosteimageimg + 'images/' + this.winRef.appConfigSite.idEtab + '/upload/' + size + '/';
    }

    selectImg(id: string): void {
        this.carousel.select(id);
    }
    ngOnInit() {
    }

    /**
    * lang
    * @returns string lang
    */
    get lang(): string {
        return this.winRef.appConfigSite.defaultlangue
    }

}
